<template>
    <div class="test-item">
        <div class="test-item-type">
            <span class="title">{{paperType[item.subjectType]}}</span>
            <span class="score">{{ `(${item.score})分`}}</span>
        </div>
        <!-- <div class="test-item-title">{{index + '、'}}{{item.title}}</div> -->
        <div style="float:left" class="test-item-title">{{index}}、</div>
        <div class="test-item-title" v-html="item.title"></div>
        <div class="test-item-answer">{{'答：' + (item.content?item.content: '')}}</div>
        <!-- <div class="test-item-answer">{{'图片: ' + (item.files?item.files: '')}}</div>
        <div class="test-item-answer">{{'图片: ' + (item.fileUrl[0]?item.fileUrl[0]: '')}}</div> -->
        <div class="test-item-answer"  v-for="(fileitem, filteindex) in item.fileUrl"
                :key="filteindex">{{'图片：' }}
                <img id="imgId" :src="fileitem?fileitem:''" @click.self="showBigImage($event)"  alt="图片"/>
        </div>
        <div class="test-item-score">
            <span style="font-weight:bold">{{`本试题 ${item.score} 分，评分`}}</span>
            <el-input type="number" size="small" v-model="item.personNewScore"></el-input>
            <span>分</span>
        </div>
        <BigImg :visible="photoVisible" :url="bigImgUrl" @closeClick="()=>{photoVisible=false}"></BigImg>
    </div>
</template>
<script>
import BigImg from "./BigImg.vue";
export default {
    name: 'TestItem',
    props: ['item', 'index','fileitem','filteindex'],
    data() {
        return {
            paperType: {
                0: '单选',
                1: '多选',
                2: '问答'
            },
            photoVisible: false,
            bigImgUrl: "",
        }
    },
    methods: {
        showBigImage(e) {
            if (e != "") {
            this.photoVisible = true;
            this.bigImgUrl = e.currentTarget.src;
            }
        }
    },
    components: {
     BigImg,
      }
}
</script>
<style lang="scss" scoped>
@import '../../../styles/variables.scss';
@import '../../../styles/mixin.scss';

.test-item {
    margin-bottom: .25rem;
    .test-item-type {
        width: 1.1rem;
        height: .3rem;
        margin-bottom: .25rem;
        line-height: .3rem;
        border: 1px solid $border_color_2EC;
        text-align: center;
        .title, .score {
            display: inline;
            vertical-align: top;
        }
        .title {
            font-size: .14rem;
            color: $font_color_51b;
        }
        .score {
            margin-left: .06rem;
            font-size: .12rem;
            color: rgba($color: $font__color_000, $alpha: 0.5);
        }
    }
    .test-item-title, .test-item-true-answer {
        margin-bottom: .15rem;
        font-size: .14rem;
        line-height: .2rem;
    }
    .test-item-title {
        color: $font_color_08E;
    }
    .test-item-answer {
        margin-bottom: .25rem;
        font-size: .13rem;
        color: $grey_font_color_80;
        line-height: .18rem;
    }
    .test-item-true-answer {
        color: $font_color_050;
    }
    .test-item-line {
        border-bottom: 1px solid $grey_border_color_e6;
    }
    .test-item-score {
        padding: .1rem 0 0;
        font-size: .14rem;
        color: $font_color_08E;
        .el-input {
            width: .7rem;
            margin: 0 .15rem;
        }
    }
}
</style>
<style lang="scss">
.test-item {
    .test-item-score {
        .el-input--small .el-input__inner {
            line-height: .3rem;
            height: .3rem;
        }
    }
}
</style>